<template>
  <section>
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex md12 class="top-breadcrumbs">
        <v-container grid-list-md>
          <v-layout>
          <v-breadcrumbs :items="breadcrumbs" divider=" / "></v-breadcrumbs>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-container grid-list-md pt-12 mb-12>
      <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-layout wrap>
            <v-flex md12 lg12>
              <h3 class="h1">门店信息</h3>
              <p class="p1">您必须亲自体验我们的产品才能真正了解它们的特别之处。 我们邀请您访问您附近的玛娅经销商</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap v-if="stores">
        <v-flex xs12 md4 v-for="(item, i) in stores" :key="item.key" :class="'store-flex store-flex' + i%3">
          <v-card flat tile class="store-card" >
            <div>
              <div class="store-img"><img :src="item.img"/></div>
              <div class="store-name">{{item.name}}</div>
              <div class="store-addr">{{item.addr}}</div>
              <div class="store-tel">联系方式：{{item.tel}}</div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <!--<v-layout wrap>
        <v-flex xs12 sm12 md12 lg12>
          <template>
            <div id="map">
                <div id="bm-view" class="bm-view"></div>
                <div id="filter-div">
                    <v-select v-model="value" :items="items" label="" flat dense outlined height="30"></v-select>
                    <v-layout wrap>
                    <v-flex md8 pr-4>
                        <div class="store-info">
                            <div class="info-icon"><v-icon size="21">mdi-map-marker</v-icon></div>
                            <div class="info-value" >{{currentStore.addr}}</div>
                        </div>
                        <div class="store-info">
                            <div class="info-icon"><v-icon size="21">mdi-phone</v-icon></div>
                            <div class="info-value">{{currentStore.tel}}</div>
                        </div>
                    </v-flex>
                    <v-flex md4>
                        <v-img :src="currentStore.img"></v-img>
                    </v-flex>
                    </v-layout>
                </div>
            </div>
          </template>
        </v-flex>
      </v-layout>-->
    </v-container>
  </section>
</template>
<script>
// import { loadBaiDuDrawMap } from '../bmap'
export default {
  data: () => ({
    isMobile: false,
    breadcrumbs: [],
    stores: []
    /*
    items: [],
    currentStore: { addr: null, tel: null },
    value: null,
    BMap: null,
    map: null,
    markerPoint: { lng: 0, lat: 0 },
    zoom: null
    */
  }),
  created () {
    this.breadcrumbs = [
      { text: '联系玛娅', disabled: true },
      { text: '门店信息', disabled: true }
    ]
    if (window.innerWidth < 960) {
      this.isMobile = true
    }
    this.getStores()
    // this.getStore()
  },
  watch: {
    value: {
      handler: function (val, oldVal) {
        this.initMap(val)
      },
      deep: true
    }
  },
  computed: {
    info () {
      return this.$store.getters.companyInfo
    }
  },
  methods: {
    getStores () {
      this.https.get('store').then(response => {
        if (response.code === 0 && response.data.store) {
          this.stores = response.data.store
        }
      })
    }
    /*
    getStore () {
      this.https.get('store', { city: this.param }).then(response => {
        if (response.code === 0 && response.data.store) {
          this.stores = response.data.store
          for (let key in this.stores) {
            this.items.push({ text: this.stores[key].name, value: key })
          }
          this.value = '0'
        }
      })
    },
    initMap (val) {
      let that = this
      loadBaiDuDrawMap().then((BMapGL) => {
        let stores = this.stores
        this.currentStore = this.stores[val]
        let map = new BMapGL.Map('bm-view')
        let active = false
        map.addControl(new BMapGL.ZoomControl({ anchor: BMAP_ANCHOR_TOP_RIGHT }))
        stores.forEach (function (item, index) {
          let point = new BMapGL.Point(item.lng, item.lat)
          active = false
          if (parseInt(val) === index) {
            active = true
          }
          that.drawMarker(map, point, active)
        })
      })
    },
    drawMarker (map, point, active) {
      let icon = '/imgs/bmarker.png'
      if (active) {
        icon = '/imgs/bmarker-actived.png'
      }
      let myIcon = new BMapGL.Icon(icon, new BMapGL.Size(40, 40), {
        anchor: new BMapGL.Size(20, 38)
      })
      let marker = new BMapGL.Marker(point, { icon: myIcon })
      map.addOverlay(marker)
      if (active) {
        if (this.isMobile) {
          map.centerAndZoom(point, 15)
        } else {
          if (this.zoom === null) {
            let centerPoint = new BMapGL.Point(104.04416, 31.410776)
            map.centerAndZoom(centerPoint, 6)
            this.zoom = 15
          } else {
            map.centerAndZoom(point, this.zoom)
          }
        }
      }
    }
    */
  }
}
</script>
<style lang="css">
  @import '../css/contact.css';
</style>
